import { useState } from "react";
import { Layout, Menu, Button, Drawer } from "antd";
import {
  MenuOutlined,
  TeamOutlined,
  LogoutOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Header } = Layout;

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("TOKEN");
    navigate("/login");
  };

  const menuItems = [
    {
      key: "home",
      label: "الرئيسية",
      icon: <HomeOutlined />,
      onClick: () => {
        navigate("/");
        setDrawerOpen(false);
      },
    },
    // {
    //   key: "families",
    //   label: "العائلات",
    //   icon: <TeamOutlined />,
    //   onClick: () => {
    //     navigate("/families");
    //     setDrawerOpen(false);
    //   },
    // },
  ];

  return (
    <Header className="flex items-center justify-between bg-gradient-to-r from-blue-600 to-blue-700 px-4 sm:px-8 shadow-md sticky top-0 z-50">
      {/* Logo / App Name */}
      <div
        className="text-white text-lg sm:text-xl font-extrabold cursor-pointer flex items-center gap-2"
        onClick={() => navigate("/")}
      >
        🏠 <span className="hidden sm:inline">نظام إدارة العائلات</span>
      </div>

      {/* Desktop Menu */}
      {/* <div className="hidden md:flex flex-1 justify-center">
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[
            location.pathname.includes("families") ? "families" : "home",
          ]}
          className="bg-transparent border-0 text-white text-base font-semibold"
          items={menuItems}
        />
      </div> */}

      {/* Desktop Logout */}
      <div className="hidden md:block">
        <Button
          type="primary"
          danger
          icon={<LogoutOutlined />}
          className="font-semibold"
          onClick={logout}
        >
          تسجيل الخروج
        </Button>
      </div>

      {/* Mobile Hamburger */}
      <div className="md:hidden flex items-center">
        <Button
          type="text"
          icon={<MenuOutlined style={{ color: "white", fontSize: 22 }} />}
          onClick={() => setDrawerOpen(true)}
        />
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={
          <div className="text-xl font-bold text-blue-700 text-center">
            نظام إدارة العائلات
          </div>
        }
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={[
            location.pathname.includes("families") ? "families" : "home",
          ]}
          items={menuItems}
          className="border-none text-base"
        />

        <div className="p-4 border-t border-gray-200">
          <Button
            block
            danger
            icon={<LogoutOutlined />}
            size="large"
            onClick={logout}
          >
            تسجيل الخروج
          </Button>
        </div>
      </Drawer>
    </Header>
  );
}
